module.exports = __webpack_public_path__ + "static/media/portfolio-example-01.16897402.jpg";